var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPesquisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pesquisa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Home_Escuro",
    transform: "translate(-913.000000, -1096.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(812.000000, 1082.000635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.118085,29.2338806 C105.186875,29.2338806 102,26.0475179 102,22.1169403 C102,18.1863628 105.186875,15 109.118085,15 C113.049295,15 116.23617,18.1863628 116.23617,22.1169403 C116.23617,26.0475179 113.049295,29.2338806 109.118085,29.2338806 Z M119,32 L116.23617,29.2338806",
    id: "pesquisa",
    transform: "translate(110.500000, 23.500000) scale(-1, 1) translate(-110.500000, -23.500000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesquisa);
export default __webpack_public_path__ + "static/media/pesquisa.6fedeae605bb1a4b1dde259aaff507f7.svg";
export { ForwardRef as ReactComponent };